class Setting {
  env: string;
  apiServerUrl: string;
  chatServerUrl: string;
  socketServerUrl: string;
  webChatUrl: string;
  cdnPrefix: string;
  oneApiUrl: string;

  constructor() {
    this.env = process.env.REACT_APP_ENV || EMPTY;
    this.apiServerUrl = process.env.REACT_APP_API_URL || EMPTY;
    this.chatServerUrl = process.env.REACT_APP_CHAT_URL || EMPTY;
    this.socketServerUrl = process.env.REACT_APP_SOCKET_URL || EMPTY;
    this.webChatUrl = process.env.REACT_APP_WEB_CHAT_URL || EMPTY;
    this.cdnPrefix = process.env.REACT_APP_CDN_PREFIX || EMPTY;
    this.oneApiUrl = process.env.REACT_APP_ONE_API_URL || EMPTY;
  }
}

const EMPTY: string = '';

const config: Setting = new Setting();

export { Setting, config };
